const InitCheckout = () => {
  function domLoaded() {
    const tbody = document.querySelector('.address-book tbody');
    const sameAddressMap = {
      billing_first_name_kr: 'shipping_first_name_kr',
      'mshop_billing_address-postnum': 'mshop_shipping_address-postnum',
      'mshop_billing_address-addr1': 'mshop_shipping_address-addr1',
      'mshop_billing_address-addr2': 'mshop_shipping_address-addr2',
      billing_email_kr: 'shipping_email',
      billing_phone_kr: 'shipping_phone',
    };
    if (tbody !== null) {
      const sameRow = document.createElement('tr');
      sameRow.classList.add('address-same-row');

      sameRow.innerHTML = `
        <td class="address-same-cell">
          <input type="radio" name="address_item">
          <label for="address_item"></label>
        </td>
        <td>회원 정보와 동일</td>
        <td></td>
      `;
      const newRow = tbody.querySelector('tr.new');
      if (newRow) {
        tbody.insertBefore(sameRow, newRow);
      } else {
        tbody.appendChild(sameRow);
      }

      sameRow.addEventListener('click', () => {
        setTimeout(() => {
          Object.entries(sameAddressMap).forEach(([fromId, toId]) => {
            const from = document.getElementById(fromId);
            const to = document.getElementById(toId);
            if (from && to) {
              to.value = from.value;
              to.dispatchEvent(new Event('change'));
            }
          });
        }, 100);
      });
    }

    const copyAddressCheckbox = document.getElementById(
      'copy_address_checkbox'
    );
    if (copyAddressCheckbox) {
      copyAddressCheckbox.addEventListener('change', () => {
        const isChecked = copyAddressCheckbox.checked;
        Object.entries(sameAddressMap).forEach(([fromId, toId]) => {
          const from = document.getElementById(fromId);
          const to = document.getElementById(toId);
          if (from && to) {
            if (isChecked) {
              to.value = from.value;
            } else {
              to.value = '';
            }
            to.dispatchEvent(new Event('change'));
          }
        });
      });
    }

    const isLoggedIn = document.body.classList.contains('logged-in');
    if (isLoggedIn) {
      const addressBook = document.querySelector('.address-book');
      if (addressBook.style.display !== 'none') {
        document.querySelector('.copy-address-btn-wrap').style.display = 'none';
      }
    }
  }
  document.addEventListener('DOMContentLoaded', domLoaded);
};
export default InitCheckout;
